module.exports = __webpack_public_path__ + "static/media/slider1.532a7187.png";